import { YM_COUNTER_CLIENT_ID, ROISTAT_VISIT_ID } from 'application/services/AnalyticsService';

import { useAuthLeadUtmMarksMutation, UtmMarkKeyTypeEnum } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { getCookieByKey, PROMOCODE_COOKIE_NAME, SBER_AGENT_ID_COOKIE_NAME } from '@shared/lib';
import { UseUTMMarksType } from './types';

const useUtmMarks = (): UseUTMMarksType => {
  const [mutation] = useAuthLeadUtmMarksMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async () => {
    const utmMarks = [];

    const ymClientId = localStorage.getItem(YM_COUNTER_CLIENT_ID);
    const roistatVisitId = localStorage.getItem(ROISTAT_VISIT_ID);

    if (ymClientId) {
      utmMarks.push({ key: UtmMarkKeyTypeEnum.YmId, value: ymClientId });
      localStorage.removeItem(YM_COUNTER_CLIENT_ID);
    }

    if (roistatVisitId) {
      utmMarks.push({ key: UtmMarkKeyTypeEnum.Roistat, value: roistatVisitId });
      localStorage.removeItem(ROISTAT_VISIT_ID);
    }

    const promocodeCookieValue = getCookieByKey(PROMOCODE_COOKIE_NAME);

    if (promocodeCookieValue) {
      utmMarks.push({ key: UtmMarkKeyTypeEnum.Promocode, value: promocodeCookieValue });
    }

    const sberAgentIdCookieValue = getCookieByKey(SBER_AGENT_ID_COOKIE_NAME);

    if (sberAgentIdCookieValue) {
      utmMarks.push({ key: UtmMarkKeyTypeEnum.SberAgentId, value: sberAgentIdCookieValue });
    }

    const mutationResult = await mutation({
      variables: { input: { utmMarks } },
    });

    return !!mutationResult.data?.utmMarksSendToAmoLead?.ok;
  };

  return [request];
};

export default useUtmMarks;
